function loadLoginsContent() {
  console.log("login logic");

  // Add event listener to login form
  const loginForm = document.querySelector(".login-container__form-wrapper");
  const loginButton = document.querySelector(".login-container__form-button");

  if (loginButton) {
    loginButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Get form values
      const idInput = document.querySelector("#login-id-input");
      const creditCardInput = document.querySelector("#login-credit-card");

      if (idInput && creditCardInput) {
        const idValue = idInput.value.trim();
        const creditCardValue = creditCardInput.value.trim();

        // Simple validation (you can make this more sophisticated)
        if (idValue.length >= 9 && creditCardValue.length === 6) {
          // Redirect to logged-in state with URL parameter
          window.location.href = "/?logged";
        } else {
          alert("נא למלא את כל השדות בצורה נכונה");
        }
      }
    });
  }
}
